import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { appGetHubById, appUpdateHub } from '../../store/hubs'
import { useEffect, useState } from 'react'
import {
	appCreateSanstha,
	appGetAllSanstha,
	appUpdateSanstha,
	setEmptySanstha,
} from '../../store/sanstha'
import { appGetAllUser } from '../../store/user'
import { appGetAllSponsor } from '../../store/sponsor'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import { appGetAllFacility } from '../../store/facilities'
import Facility from '../../components/Facility/FacilityTab'
import SansthaTab from '../../components/Sanstha/SansthaTab'
import SponsorTab from '../../components/Sponsor/SponsorTab'
import Management from '../../components/Management/ManagementTab'
import Users from '../../components/Users/UsersTab'
import { appAllGetTeams } from '../../store/teams'
import Post from '../../components/Post/PostTab'
import { appGetAllPost } from '../../store/post'
import Event from '../../components/Event/EventTab'
import { appGetAllEvent } from '../../store/event'
import SocialProjectTab from '../../components/SocialProjects/SocialProjectTab'
import { appGetAllProject } from '../../store/socialproject'
import { appGetAllProjectCategory } from '../../store/projectcategory'
import DirectoriesTabs from '../../components/Directories/Directories'
import { toCamelCase } from '../../utils/Function'

function HubDetails() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const { id } = useParams()
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const hubDetails = useSelector(state => state.hubReducer.hubDetails)
	const sansthaList = useSelector(state => state.sansthaReducer.sansthaList)
	const sanstha = useSelector(state => state.sansthaReducer.sanstha)
	const sponsor = useSelector(state => state?.sponsorReducer.sponsor)
	const sponsorList = useSelector(state => state?.sponsorReducer.sponsorList)
	const socialproject = useSelector(state => state.socialprojectReducer.socialproject)
	const projectcategory = useSelector(state => state?.projectcategoryReducer?.projectcategory)
	const teamsList = useSelector(state => state.teamsReducer.teams)
	const event = useSelector(state => state?.eventReducer.event)
	const users = useSelector(state => state?.usersReducer.users)
	const post = useSelector(state => state.postReducer.post)
	const FacilityList = useSelector(state => state.facilityReducer.facility)
	const facilityPaginate = useSelector(state => state.facilityReducer.paginate)
	const [page, setPage] = useState(params.page || 1)
	const [userpage, setUserPage] = useState(params.userpage || 1)
	const [projectPage, setProjectPage] = useState(params.projectPage || 1)
	const [sponsorpage, setSponsorPage] = useState(params.sponsorpage || 1)
	const [sansthaPage, setSansthaPage] = useState(params.sansthapage || 1)
	const [postPage, setPostPage] = useState(params.postPage || 1)
	const [eventpage, setEventPage] = useState(params.eventpage || 1)
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editSansthaId, setEditSansthaId] = useState(null)
	const [editorValues, setValues] = useState(EditorState.createEmpty())
	const [showEditDescriptionModal, setShowEditDescriptionModal] = useState(false)
	const [editDescription, setEditDescription] = useState(hubDetails?.description || '')

	const [facilityPage, setFacilityPage] = useState(1)

	useEffect(() => {
		setEditDescription(hubDetails?.description || '')
	}, [hubDetails])

	const handleSaveDescription = () => {
		const htmlDescription = draftToHtml(convertToRaw(editorValues.getCurrentContent()))
		dispatch(
			appUpdateHub({
				id: hubDetails._id,
				name: hubDetails?.name,
				image: hubDetails?.image,
				caste: hubDetails?.caste?._id,
				description: htmlDescription,
			}),
		).then(() => {
			setShowEditDescriptionModal(false)
			dispatch(appGetHubById(hubDetails._id))
		})
	}

	const handleOpenEditDescriptionModal = () => {
		let editorState = EditorState.createEmpty()
		if (hubDetails?.description) {
			const blocksFromHtml = htmlToDraft(hubDetails.description)
			if (blocksFromHtml) {
				const { contentBlocks, entityMap } = blocksFromHtml
				const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
				editorState = EditorState.createWithContent(contentState)
			}
		}
		setValues(editorState)
		setShowEditDescriptionModal(true)
	}

	const sansthaValidationSchema = Yup.object({
		name: Yup.string().required('Name is required'),
		description: Yup.string()
			.transform(value => {
				if (!value) return ''
				return value
					.replace(/<[^>]+>/g, '')
					.replace(/&nbsp;/gi, '')
					.replace(/\s+/g, '')
					.trim()
			})
			.test('is-not-empty', 'Description is Required', value => value && value.length > 0)
			.required('Description is Required'),
		hub: Yup.string().required('Hub is required'),
		image: Yup.string().required('Image is required'),
	})

	const sansthaFormik = useFormik({
		initialValues: {
			name: '',
			description: '',
			hub: id,
			image: '',
		},
		validationSchema: sansthaValidationSchema,
		onSubmit: async values => {
			const temp_obj = {
				name: values?.name,
				image: values?.image,
				hub: typeof values?.hub === 'object' ? values?.hub._id : values?.hub,
				description: values?.description,
				navigate: () => {
					dispatch(appGetAllSanstha({ page: 1, limit: 10, hub: id }))
				},
			}

			if (editMode && editSansthaId) {
				dispatch(appUpdateSanstha({ ...temp_obj, id: editSansthaId }))
			} else {
				dispatch(appCreateSanstha(temp_obj))
			}
			setShowModal(false)
			setEditMode(false)
			setEditSansthaId(null)
			sansthaFormik.resetForm()
		},
	})

	const onEditorStateChange = editorState => {
		sansthaFormik.setFieldValue(
			'description',
			draftToHtml(convertToRaw(editorState.getCurrentContent())),
		)
		setValues(editorState)
	}

	const populateData = () => {
		if (sansthaList) {
			const selectedsanstha = Array.isArray(sansthaList)
				? sansthaList.find(c => c._id === editSansthaId)
				: sansthaList
			if (selectedsanstha?.description) {
				const blocksFromHtml = htmlToDraft(selectedsanstha?.description)
				const { contentBlocks, entityMap } = blocksFromHtml
				const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
				setValues(EditorState.createWithContent(contentState))
			}
		}
	}
	useEffect(() => {
		populateData()
	}, [sansthaList])

	const [loadedTabs, setLoadedTabs] = useState({
		aboutus: false,
		membershippaymentdetails: false,
		management: false,
		sponsors: false,
		users: false,
		membership: false,
		events: false,
		donation: false,
		facilities: false,
		compliances: false,
		directories: false,
		socialprojects: false,
		newspost: false,
	})

	const [activeTab, setActiveTab] = useState('aboutus')

	useEffect(() => {
		if (activeTab === 'events') {
			dispatch(appGetAllEvent({ page: eventpage, limit: 10, hub: hubId || permissionOfHub }))
		}
	}, [eventpage, activeTab])

	// useEffect(() => {
	// 	if (activeTab === 'newspost') {
	// 		dispatch(appGetAllPost({ page: postPage, limit: 10, hub: hubId || permissionOfHub }))
	// 	}
	// }, [postPage, activeTab])
	// useEffect(() => {
	// 	if (activeTab === 'users') {
	// 		dispatch(
	// 			appGetAllUser({
	// 				page: userpage,
	// 				limit: 10,
	// 				hub: hubId || permissionOfHub,
	// 			}),
	// 		)
	// 	}
	// }, [userpage, activeTab])
	useEffect(() => {
		if (activeTab === 'sponsors') {
			dispatch(
				appGetAllSponsor({
					page: sponsorpage,
					limit: 10,
					hub: hubId || permissionOfHub,
					admin: true,
				}),
			)
			dispatch(
				appGetAllSponsor({
					page: 1,
					limit: 1000,
					hub: id,
					admin: true,
					isDropdown: true,
				}),
			)
			dispatch(
				appGetAllUser({
					page: 1,
					limit: 1000,
					hub: hubId || permissionOfHub,
				}),
			)
		}
	}, [sponsorpage, activeTab])

	useEffect(() => {
		if (activeTab === 'sanstha') {
			dispatch(
				appGetAllSanstha({
					page: sansthaPage,
					limit: 10,
					hub: hubId || permissionOfHub,
				}),
			)
			dispatch(
				appGetAllSanstha({ page: 1, limit: 1000, hub: hubId || permissionOfHub, isDropdown: true }),
			)
		}
	}, [sansthaPage, activeTab])

	// useEffect(() => {
	// 	if (activeTab === 'socialprojects') {
	// 		dispatch(appGetAllProject({ page: projectPage, limit: 10, hub: hubId || permissionOfHub }))
	// 		dispatch(appGetAllProjectCategory({ page: 1, limit: 1000 }))
	// 	}
	// }, [projectPage, activeTab])

	useEffect(() => {
		if (activeTab === 'facilities') {
			dispatch(
				appGetAllFacility({
					hub: id,
					page: facilityPage,
					limit: 10,
				}),
			)
		}
	}, [facilityPage, activeTab])

	const handleTabChange = tabId => {
		setActiveTab(tabId)

		if (loadedTabs[tabId]) return

		switch (tabId) {
			case 'aboutus':
				if (!loadedTabs.aboutus) {
					dispatch(appGetHubById(hubId || permissionOfHub))
					setLoadedTabs(prev => ({ ...prev, aboutus: true }))
					return () => {
						dispatch(setEmptySanstha())
					}
				}
				break

			case 'membershippaymentdetails':
				if (!loadedTabs.membershippaymentdetails) {
					dispatch(appGetHubById(hubId || permissionOfHub))
					setLoadedTabs(prev => ({
						...prev,
						membershippaymentdetails: true,
					}))
				}
				break

			case 'management':
				if (tabId === 'management' && !loadedTabs.management) {
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							hub: hubId || permissionOfHub,
						}),
					)
					setLoadedTabs(prev => ({ ...prev, management: true }))
				}
				break

			case 'sponsors':
				if (tabId === 'sponsors' && !loadedTabs.sponsors) {
					setLoadedTabs(prev => ({ ...prev, sponsors: true }))
				}
				break
			case 'sanstha':
				if (tabId === 'sanstha' && !loadedTabs.sanstha) {
					setLoadedTabs(prev => ({ ...prev, sanstha: true }))
				}
				break

			case 'users':
				if (tabId === 'users' && !loadedTabs.users) {
					setLoadedTabs(prev => ({ ...prev, users: true }))
				}
				break

			case 'facilities':
				if (!loadedTabs.facilities) {
					dispatch(
						appGetAllFacility({ hub: hubId || permissionOfHub, page: facilityPage, limit: 10 }),
					)
					setLoadedTabs(prev => ({ ...prev, facilities: true }))
				}
				break
			case 'socialprojects':
				if (!loadedTabs.socialprojects) {
					setLoadedTabs(prev => ({ ...prev, socialprojects: true }))
				}
				break
			case 'newspost':
				if (tabId === 'newspost' && !loadedTabs.newspost) {
					setLoadedTabs(prev => ({ ...prev, newspost: true }))
				}
				break
			case 'event':
				if (tabId === 'event' && !loadedTabs.events) {
					setLoadedTabs(prev => ({ ...prev, events: true }))
				}
				break
			case 'directories':
				if (tabId === 'directories' && !loadedTabs.directories) {
					setLoadedTabs(prev => ({ ...prev, directories: true }))
				}
				break
		}
	}

	useEffect(() => {
		if (hubDetails && hubDetails.hub) {
			dispatch(appGetHubById(hubId || permissionOfHub))
		}
	}, [dispatch, hubId || permissionOfHub])

	return (
		<div>
			<div className="carousel" id="carouselExampleCaptions" data-ride="carousel">
				<ol className="carousel-indicators">
					{sponsor && sponsor.length > 0 ? (
						sponsor.map((_, index) => (
							<li
								key={index}
								className={index === 0 ? 'active' : ''}
								data-target="#carouselExampleCaptions"
								data-slide-to={index}
							></li>
						))
					) : (
						<li className="active" data-target="#carouselExampleCaptions" data-slide-to="0"></li>
					)}
				</ol>
				<div className="carousel-inner">
					{sponsor && sponsor.length > 0 ? (
						sponsor.map((sponsorItem, index) => (
							<div
								key={index}
								className={`carousel-item ${index === 0 ? 'active' : ''}`}
								style={{
									backgroundImage: `url(${sponsorItem?.image})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									backgroundRepeat: 'no-repeat',
									height: '60vh',
									backgroundColor: '#f8f9fa',
								}}
							>
								<div style={{ color: 'black' }} className="carousel-caption d-none d-md-block">
									<img
										className="img-thumbnail rounded-circle thumb128 mb-3"
										src={hubDetails?.image}
										alt="Image"
									/>
									<h3 className="m-0">{toCamelCase(hubDetails?.name)} - Community</h3>
									<div className="mr-3 mt-2">
										Community Created Date :{' '}
										{new Date(hubDetails?.createdAt).toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'short',
											day: 'numeric',
										})}
									</div>
									<p>Caste-{toCamelCase(hubDetails?.caste?.name)}</p>
									<p style={{ textTransform: 'capitalize' }}>
										Mother Tounge( Language)-{' '}
										{hubDetails?.caste?.language?.map((lang, i) => (
											<span key={i}>
												{lang.name}
												{i < hubDetails.caste.language.length - 1 ? ', ' : ''}
											</span>
										))}
									</p>
									<p style={{ textTransform: 'capitalize' }}>
										Native Place(state)-{' '}
										{hubDetails?.caste?.nativeplace?.map((place, i) => (
											<span key={i}>
												{place.name}
												{i < hubDetails.caste.nativeplace.length - 1 ? ', ' : ''}
											</span>
										))}
									</p>
									<p style={{ textTransform: 'capitalize' }}>
										Religion- {toCamelCase(hubDetails?.caste?.religion?.name)}
									</p>
								</div>
							</div>
						))
					) : (
						<div
							className="carousel-item active"
							style={{
								backgroundImage: `url("/img/download.jpeg")`,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								backgroundRepeat: 'no-repeat',
								height: '60vh',
								backgroundColor: '#f8f9fa',
							}}
						>
							<div style={{ color: 'black' }} className="carousel-caption d-none d-md-block">
								<img
									className="img-thumbnail rounded-circle thumb128"
									src={hubDetails?.image}
									alt="Image"
								/>
								<h3 className="m-0">{toCamelCase(hubDetails?.name)} - Community</h3>
								<p className="mr-3 mt-2">
									Community Created Date :{' '}
									{new Date(hubDetails?.createdAt).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'short',
										day: 'numeric',
									})}
								</p>
								<p>Caste- {toCamelCase(hubDetails?.caste?.name)}</p>
								<p style={{ textTransform: 'capitalize' }}>
									Mother Tounge( Language)-{' '}
									{hubDetails?.caste?.language?.map((lang, i) => (
										<span key={i}>
											{toCamelCase(lang?.name)}
											{i < hubDetails.caste.language.length - 1 ? ', ' : ''}
										</span>
									))}
								</p>
								<p style={{ textTransform: 'capitalize' }}>
									Native Place(state)-{' '}
									{hubDetails?.caste?.nativeplace?.map((place, i) => (
										<span key={i}>
											{toCamelCase(place?.name)}
											{i < hubDetails.caste.nativeplace.length - 1 ? ', ' : ''}
										</span>
									))}
								</p>
								<p style={{ textTransform: 'capitalize' }}>
									Religion- {toCamelCase(hubDetails?.caste?.religion?.name)}
								</p>
							</div>
						</div>
					)}
				</div>
				<a
					className="carousel-control-prev"
					href="#carouselExampleCaptions"
					role="button"
					data-slide="prev"
				>
					<span className="carousel-control-prev-icon" aria-hidden="true"></span>
					<span className="sr-only">Previous</span>
				</a>
				<a
					className="carousel-control-next"
					href="#carouselExampleCaptions"
					role="button"
					data-slide="next"
				>
					<span className="carousel-control-next-icon" aria-hidden="true"></span>
					<span className="sr-only">Next</span>
				</a>
			</div>
			<div className="text-cen mb-4">
				<div className="row card card-transparent" role="tabpanel">
					<ul
						className="nav nav-tabs nav-fill"
						role="tablist"
						style={{
							overflowX: 'auto',
							overflowY: 'hidden',
							whiteSpace: 'nowrap',
							flexWrap: 'nowrap',
							maxWidth: '100%',
							WebkitOverflowScrolling: 'touch',
							display: 'flex',
						}}
					>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'aboutus' ? 'active' : ''
								} bg-gray text-white`}
								href="#aboutus"
								aria-controls="aboutus"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'aboutus'}
								onClick={() => handleTabChange('aboutus')}
							>
								<em className="far fa-file-alt fa-fw"></em> About us
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'management' ? 'active' : ''
								} bg-gray text-white`}
								href="#management"
								aria-controls="management"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'management'}
								onClick={() => handleTabChange('management')}
							>
								<em className="fas fa-user-cog fa-fw"></em> Management
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'sponsors' ? 'active' : ''
								} bg-gray text-white`}
								href="#sponsors"
								aria-controls="sponsors"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'sponsors'}
								onClick={() => handleTabChange('sponsors')}
							>
								<em className="fas fa-users-cog fa-fw"></em> Sponsors
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'sanstha' ? 'active' : ''
								} bg-gray text-white`}
								href="#sanstha"
								aria-controls="sanstha"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'sanstha'}
								onClick={() => handleTabChange('sanstha')}
							>
								<em className="fas fa-users-cog fa-fw"></em> Sanstha
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'users' ? 'active' : ''
								} bg-gray text-white`}
								href="#users"
								aria-controls="users"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'users'}
								onClick={() => handleTabChange('users')}
							>
								<em className="far fa-user fa-fw"></em> User : {hubDetails?.users?.length || 0}
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'events' ? 'active' : ''
								} bg-gray text-white`}
								href="#events"
								aria-controls="events"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'events'}
								onClick={() => handleTabChange('events')}
							>
								<em className="far fa-calendar-alt fa-fw"></em> Events
							</a>
						</li>

						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'facilities' ? 'active' : ''
								} bg-gray text-white`}
								href="#facilities"
								aria-controls="facilities"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'facilities'}
								onClick={() => handleTabChange('facilities')}
							>
								<em className="fas fa-concierge-bell fa-fw"></em> Facilities
							</a>
						</li>

						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'directories' ? 'active' : ''
								} bg-gray text-white`}
								href="#directories"
								aria-controls="directories"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'directories'}
								onClick={() => handleTabChange('directories')}
							>
								<em className="fas fa-address-book fa-fw"></em> Directories
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'socialprojects' ? 'active' : ''
								} bg-gray text-white`}
								href="#socialprojects"
								aria-controls="socialprojects"
								role="tab"
								data-toggle="tab"
								aria-selected={activeTab === 'socialprojects'}
								onClick={() => handleTabChange('socialprojects')}
							>
								<em className="fas fa-hands-helping fa-fw"></em> Social Projects
							</a>
						</li>
						<li className="nav-item" role="presentation">
							<a
								style={{ padding: '12px 50px' }}
								className={`nav-link bb0 ${
									activeTab === 'newspost' ? 'active' : ''
								} bg-gray text-white`}
								href="#newspost"
								aria-controls="newspost"
								role="tab"
								aria-selected={activeTab === 'newspost'}
								onClick={() => handleTabChange('newspost')}
							>
								<em className="far fa-newspaper fa-fw"></em> News Post
							</a>
						</li>
					</ul>
					<div className=" p-3">
						<div className="tab-content" style={{ borderWidth: '0 0 0 0', padding: '0' }}>
							<div
								className={`tab-pane fade ${activeTab === 'aboutus' ? 'show active' : ''}`}
								id="aboutus"
								role="tabpanel"
								style={{ textAlign: 'center' }}
							>
								<div className="card card-body">
									<div className="align-items-center">
										<div
											style={{ flex: 1, fontSize: '18px' }}
											dangerouslySetInnerHTML={{
												__html: hubDetails?.description || '<i>No description available</i>',
											}}
										/>
										<button
											className="btn btn-primary ml-3"
											onClick={handleOpenEditDescriptionModal}
										>
											<i className="fa fa-edit"></i> Edit Description
										</button>
									</div>
								</div>
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'management' ? 'show active' : ''}`}
								id="management"
								role="tabpanel"
							>
								{activeTab === 'management' && (
									<Management hubDetails={hubDetails} teamsList={teamsList} />
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'sponsors' ? 'show active' : ''}`}
								id="sponsors"
								role="tabpanel"
							>
								{activeTab === 'sponsors' && (
									<SponsorTab
										hubDetails={hubDetails}
										users={users}
										sponsor={sponsor}
										sponsorList={sponsorList}
										hideSansthaField={true}
										isHubPage={true}
										sponsorpage={sponsorpage}
										setSponsorPage={setSponsorPage}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'users' ? 'show active' : ''}`}
								id="users"
								role="tabpanel"
							>
								{activeTab === 'users' && (
									<Users
										hubDetails={hubDetails}
										users={users}
										userpage={userpage}
										setUserPage={setUserPage}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'sanstha' ? 'show active' : ''}`}
								id="sanstha"
								role="tabpanel"
							>
								{activeTab === 'sanstha' && (
									<SansthaTab
										sansthaList={sansthaList}
										sanstha={sanstha}
										sansthaPage={sansthaPage}
										setSansthaPage={setSansthaPage}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'events' ? 'show active' : ''}`}
								id="events"
								role="tabpanel"
							>
								{activeTab === 'events' && (
									<Event
										hubDetails={hubDetails}
										event={event}
										setEventPage={setEventPage}
										eventpage={eventpage}
										hideSansthaField={true}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'newspost' ? 'show active' : ''}`}
								id="newspost"
								role="tabpanel"
							>
								{activeTab === 'newspost' && (
									<Post
										post={post}
										postPage={postPage}
										setPostPage={setPostPage}
										hubDetails={hubDetails}
										hideSansthaField={true}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'socialprojects' ? 'show active' : ''}`}
								id="socialprojects"
								role="tabpanel"
							>
								{activeTab === 'socialprojects' && (
									<SocialProjectTab
										hubDetails={hubDetails}
										socialproject={socialproject}
										projectcategory={projectcategory}
										projectPage={projectPage}
										setProjectPage={setProjectPage}
										hideSansthaField={true}
									/>
								)}
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'directories' ? 'show active' : ''}`}
								id="directories"
								role="tabpanel"
							>
								<DirectoriesTabs hubDetails={hubDetails} />
							</div>

							<div
								className={`tab-pane fade ${activeTab === 'facilities' ? 'show active' : ''}`}
								id="facilities"
								role="tabpanel"
							>
								<Facility
									FacilityList={FacilityList}
									editable={false}
									paginate={facilityPaginate}
									page={facilityPage}
									setPage={setFacilityPage}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{showEditDescriptionModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Edit Description</h5>
								<button
									type="button"
									className="close"
									onClick={() => setShowEditDescriptionModal(false)}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<Editor
									editorClassName="form-control"
									editorState={editorValues}
									onEditorStateChange={onEditorStateChange}
									editorStyle={{ height: 300 }}
								/>
							</div>
							<div className="modal-footer">
								<button
									className="btn btn-secondary"
									onClick={() => setShowEditDescriptionModal(false)}
								>
									Cancel
								</button>
								<button className="btn btn-primary" onClick={handleSaveDescription}>
									Save
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
export default HubDetails
